/*@flow*/
import type { ActionT, StateRecord } from './types';
import setIn from 'lib/setIn';

function enableDrawing(s: StateRecord) {
  const geojson = s.getIn(['decks', 'polygon', 'geojson'], null);
  return s
    .set('mode', 'DRAWING')
    .setIn(['decks', 'drawPoly', 'active'], true)
    .setIn(['decks', 'drawPoly', 'geojson'], geojson)
    .deleteIn(['decks', 'marker'])
    .deleteIn(['decks', 'point'])
    .deleteIn(['decks', 'polygon']);
}

function disableDrawing(s: StateRecord) {
  return s
    .setIn(['mode'], 'READY')
    .setIn(['decks', 'drawPoly', 'active'], false)
    .deleteIn(['decks', 'drawPoly', 'geojson']);
}

export default (state: StateRecord, action: ActionT) => {
  let newState = state;
  const { type, payload } = action;

  switch (type) {
    case 'ENABLE_DRAWING':
      newState = enableDrawing(newState);
      break;
    case 'DISABLE_DRAWING':
      newState = disableDrawing(newState);
      break;
    case 'SET_RECORD':
      if (payload) {
        newState = setIn(newState)(payload);
      }
      break;
    default:
      throw new Error('Unrecognized action `' + type + '`');
  }
  return newState;
};
